// src/hooks/useFetchPrices.js
import { useState, useEffect } from 'react';
import api from '../utils/api'; // Adjust based on your API utility file

const useFetchPrices = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await api.get('/prices'); // Adjust the endpoint as needed
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, []);

  return { data, loading, error };
};

export default useFetchPrices;
